import { brand } from '@/config/brands'
import { newTrack } from '@/track'
import { useSpreadInfoStore, useUserStore } from '@/stores'

declare function fbq(command: string, event: string, params?: object, options?: object): void

function isFbqAvailable() {
  return typeof fbq !== 'undefined'
}

function createFbqEventId(eventName: string) {
  const env = import.meta.env.MODE.includes('production') ? 'p' : 't'
  const memberId = useUserStore().memberId || 'guest'
  const random = Math.random().toString(36).slice(2, 10).padEnd(8, '0')
  return `${env}_${brand}_h5_${eventName}_${new Date().getTime()}_${memberId}_${random}`
}

function canReportToServer(): boolean {
  return !!(useUserStore().memberId && useSpreadInfoStore().pId)
}

export function pushFbqEvent(event: string, params?: object, serverEventCode?: string) {
  if (!isFbqAvailable())
    return
  const eventId = createFbqEventId(event)
  if (serverEventCode && canReportToServer())
    newTrack(serverEventCode, { ...params, event_id: eventId })
  fbq('track', event, params, { eventID: eventId })
}

export function pushFbqCustomEvent(event: string, params?: object, serverEventCode?: string) {
  if (!isFbqAvailable())
    return
  const eventId = createFbqEventId(event)
  if (serverEventCode && canReportToServer())
    newTrack(serverEventCode, { ...params, event_id: eventId })
  fbq('trackCustom', event, params, { eventID: eventId })
}

// 只生成 eventId，不调 fbq，用于支付透传
export function createFbEventId(eventName: string) {
  return createFbqEventId(eventName)
}
